import styled, { css } from 'styled-components'

import { StyledLinkFlex } from 'modules/shared/styles'

import { colors } from 'utils/colors'

const BaseTruncateStyle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LeadOwner = styled.div<{ color: keyof typeof colors }>`
  align-items: center;
  color: ${(p) => p.theme.colors[p.color]};
  display: flex;
  text-transform: capitalize;
  ${BaseTruncateStyle}
`

export const LastActivity = styled.div`
  ${BaseTruncateStyle}
`

export const DateTime = styled.div`
  ${(p) => p.theme.font({ color: 'gray5', size: 13, weight: 'medium' })};
  letter-spacing: 0;
  ${BaseTruncateStyle}
`

export const LeadInfoWrapper = styled(StyledLinkFlex)`
  display: block;
  text-decoration: none;
  width: 100%;
  height: 100%;

  .lead-status {
    color: ${(p) => p.theme.colors.red};
    text-decoration: none;
    font-style: italic;
    white-space: nowrap;
  }

  & {
    :visited #lead-details-wrapper div {
      color: ${(p) => p.theme.colors.defaultText};
    }

    :visited .lead-status {
      color: ${(p) => p.theme.colors.red};
      font-style: italic;
    }
  }

  &:hover {
    text-decoration: none;

    .lead-name {
      text-decoration: underline;
    }
  }
`
